// Imports
var ___CSS_LOADER_API_IMPORT___ = require("D:\\soft\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed[data-v-a987f07a]{position:fixed;top:0;left:0;right:0;z-index:99}", ""]);
// Exports
module.exports = exports;
